// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Image_carouselContainer__FfBZr","imagesSection":"Image_imagesSection__IvgYF","scrollButton":"Image_scrollButton__Kd859"};